import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AppType = /*#__PURE__*/function (AppType) {
  AppType[AppType["APP_TYPE_ALL"] = 0] = "APP_TYPE_ALL";
  AppType[AppType["APP_TYPE_APP"] = 1] = "APP_TYPE_APP";
  AppType[AppType["APP_TYPE_ADDON"] = 2] = "APP_TYPE_ADDON";
  return AppType;
}(AppType || {});
var EndOfTrialActions = /*#__PURE__*/function (EndOfTrialActions) {
  EndOfTrialActions[EndOfTrialActions["END_OF_TRIAL_ACTIONS_DO_NOTHING"] = 0] = "END_OF_TRIAL_ACTIONS_DO_NOTHING";
  return EndOfTrialActions;
}(EndOfTrialActions || {});
var LmiCategory = /*#__PURE__*/function (LmiCategory) {
  LmiCategory[LmiCategory["LMI_CATEGORY_NOT_SET"] = 0] = "LMI_CATEGORY_NOT_SET";
  LmiCategory[LmiCategory["LMI_CATEGORY_WEBSITE"] = 1] = "LMI_CATEGORY_WEBSITE";
  LmiCategory[LmiCategory["LMI_CATEGORY_CONTENT_AND_EXPERIENCE"] = 2] = "LMI_CATEGORY_CONTENT_AND_EXPERIENCE";
  LmiCategory[LmiCategory["LMI_CATEGORY_LISTINGS"] = 3] = "LMI_CATEGORY_LISTINGS";
  LmiCategory[LmiCategory["LMI_CATEGORY_REPUTATION"] = 4] = "LMI_CATEGORY_REPUTATION";
  LmiCategory[LmiCategory["LMI_CATEGORY_SEO"] = 5] = "LMI_CATEGORY_SEO";
  LmiCategory[LmiCategory["LMI_CATEGORY_SOCIAL"] = 6] = "LMI_CATEGORY_SOCIAL";
  LmiCategory[LmiCategory["LMI_CATEGORY_ADVERTISING"] = 7] = "LMI_CATEGORY_ADVERTISING";
  return LmiCategory;
}(LmiCategory || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EditionUpgradeAction = /*#__PURE__*/function (EditionUpgradeAction) {
  EditionUpgradeAction[EditionUpgradeAction["EDITION_UPGRADE_ACTION_UNSET"] = 0] = "EDITION_UPGRADE_ACTION_UNSET";
  EditionUpgradeAction[EditionUpgradeAction["EDITION_UPGRADE_ACTION_CREATE_ORDER"] = 1] = "EDITION_UPGRADE_ACTION_CREATE_ORDER";
  EditionUpgradeAction[EditionUpgradeAction["EDITION_UPGRADE_ACTION_CONTACT_SALES"] = 2] = "EDITION_UPGRADE_ACTION_CONTACT_SALES";
  EditionUpgradeAction[EditionUpgradeAction["EDITION_UPGRADE_ACTION_CUSTOM_ORDER"] = 3] = "EDITION_UPGRADE_ACTION_CUSTOM_ORDER";
  return EditionUpgradeAction;
}(EditionUpgradeAction || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SuggestionReason = /*#__PURE__*/function (SuggestionReason) {
  SuggestionReason[SuggestionReason["SUGGESTION_REASON_INVALID"] = 0] = "SUGGESTION_REASON_INVALID";
  SuggestionReason[SuggestionReason["SUGGESTION_REASON_START_OFFERING"] = 1] = "SUGGESTION_REASON_START_OFFERING";
  SuggestionReason[SuggestionReason["SUGGESTION_REASON_ALREADY_OFFER"] = 2] = "SUGGESTION_REASON_ALREADY_OFFER";
  SuggestionReason[SuggestionReason["SUGGESTION_REASON_WORK_WELL_WITH_OTHER_PRODUCTS"] = 3] = "SUGGESTION_REASON_WORK_WELL_WITH_OTHER_PRODUCTS";
  SuggestionReason[SuggestionReason["SUGGESTION_REASON_WANT_TO_USE_MYSELF"] = 4] = "SUGGESTION_REASON_WANT_TO_USE_MYSELF";
  SuggestionReason[SuggestionReason["SUGGESTION_REASON_OTHER"] = 5] = "SUGGESTION_REASON_OTHER";
  return SuggestionReason;
}(SuggestionReason || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DeliveryMethod = /*#__PURE__*/function (DeliveryMethod) {
  DeliveryMethod[DeliveryMethod["DELIVERY_METHOD_INVALID"] = 0] = "DELIVERY_METHOD_INVALID";
  DeliveryMethod[DeliveryMethod["DELIVERY_METHOD_PRODUCT"] = 1] = "DELIVERY_METHOD_PRODUCT";
  DeliveryMethod[DeliveryMethod["DELIVERY_METHOD_SERVICE"] = 2] = "DELIVERY_METHOD_SERVICE";
  return DeliveryMethod;
}(DeliveryMethod || {});
var ItemType = /*#__PURE__*/function (ItemType) {
  ItemType[ItemType["ITEM_TYPE_NOT_SPECIFIED"] = 0] = "ITEM_TYPE_NOT_SPECIFIED";
  ItemType[ItemType["ITEM_TYPE_APP"] = 1] = "ITEM_TYPE_APP";
  ItemType[ItemType["ITEM_TYPE_ADDON"] = 2] = "ITEM_TYPE_ADDON";
  ItemType[ItemType["ITEM_TYPE_PACKAGE"] = 3] = "ITEM_TYPE_PACKAGE";
  return ItemType;
}(ItemType || {});
var OrderFormFilter = /*#__PURE__*/function (OrderFormFilter) {
  OrderFormFilter[OrderFormFilter["ORDER_FORM_FILTER_UNSPECIFIED"] = 0] = "ORDER_FORM_FILTER_UNSPECIFIED";
  OrderFormFilter[OrderFormFilter["ORDER_FORM_FILTER_HAS_ORDER_FORM"] = 1] = "ORDER_FORM_FILTER_HAS_ORDER_FORM";
  OrderFormFilter[OrderFormFilter["ORDER_FORM_FILTER_NO_ORDER_FORM"] = 2] = "ORDER_FORM_FILTER_NO_ORDER_FORM";
  return OrderFormFilter;
}(OrderFormFilter || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ListActivatableItemsSortField = /*#__PURE__*/function (ListActivatableItemsSortField) {
  ListActivatableItemsSortField[ListActivatableItemsSortField["LIST_ACTIVATABLE_ITEMS_SORT_FIELD_NOT_SPECIFIED"] = 0] = "LIST_ACTIVATABLE_ITEMS_SORT_FIELD_NOT_SPECIFIED";
  ListActivatableItemsSortField[ListActivatableItemsSortField["LIST_ACTIVATABLE_ITEMS_SORT_FIELD_DEFAULT_NAME"] = 1] = "LIST_ACTIVATABLE_ITEMS_SORT_FIELD_DEFAULT_NAME";
  return ListActivatableItemsSortField;
}(ListActivatableItemsSortField || {});
var ListOwnedItemsFilterOptionsAppType = /*#__PURE__*/function (ListOwnedItemsFilterOptionsAppType) {
  ListOwnedItemsFilterOptionsAppType[ListOwnedItemsFilterOptionsAppType["NOT_SPECIFIED"] = 0] = "NOT_SPECIFIED";
  ListOwnedItemsFilterOptionsAppType[ListOwnedItemsFilterOptionsAppType["ALL"] = 1] = "ALL";
  ListOwnedItemsFilterOptionsAppType[ListOwnedItemsFilterOptionsAppType["APPLICATION"] = 2] = "APPLICATION";
  ListOwnedItemsFilterOptionsAppType[ListOwnedItemsFilterOptionsAppType["ADDON"] = 3] = "ADDON";
  return ListOwnedItemsFilterOptionsAppType;
}(ListOwnedItemsFilterOptionsAppType || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["DESCENDING"] = 0] = "DESCENDING";
  SortDirection[SortDirection["ASCENDING"] = 1] = "ASCENDING";
  return SortDirection;
}(SortDirection || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FeeAmountType = /*#__PURE__*/function (FeeAmountType) {
  FeeAmountType[FeeAmountType["FEE_AMOUNT_TYPE_INVALID"] = 0] = "FEE_AMOUNT_TYPE_INVALID";
  FeeAmountType[FeeAmountType["FEE_AMOUNT_TYPE_FIXED"] = 1] = "FEE_AMOUNT_TYPE_FIXED";
  FeeAmountType[FeeAmountType["FEE_AMOUNT_TYPE_PERCENTAGE"] = 2] = "FEE_AMOUNT_TYPE_PERCENTAGE";
  return FeeAmountType;
}(FeeAmountType || {});
var FeeType = /*#__PURE__*/function (FeeType) {
  FeeType[FeeType["FEE_TYPE_INVALID"] = 0] = "FEE_TYPE_INVALID";
  FeeType[FeeType["FEE_TYPE_MANAGEMENT"] = 1] = "FEE_TYPE_MANAGEMENT";
  return FeeType;
}(FeeType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DiscountType = /*#__PURE__*/function (DiscountType) {
  DiscountType[DiscountType["DISCOUNT_TYPE_FIXED_AMOUNT"] = 0] = "DISCOUNT_TYPE_FIXED_AMOUNT";
  DiscountType[DiscountType["DISCOUNT_TYPE_PERCENT_AMOUNT"] = 1] = "DISCOUNT_TYPE_PERCENT_AMOUNT";
  DiscountType[DiscountType["DISCOUNT_TYPE_FIXED_NUMBER_OF_UNITS"] = 2] = "DISCOUNT_TYPE_FIXED_NUMBER_OF_UNITS";
  DiscountType[DiscountType["DISCOUNT_TYPE_FIXED_AMOUNT_PER_UNIT"] = 3] = "DISCOUNT_TYPE_FIXED_AMOUNT_PER_UNIT";
  return DiscountType;
}(DiscountType || {});
var PriceDisplayOverride = /*#__PURE__*/function (PriceDisplayOverride) {
  PriceDisplayOverride[PriceDisplayOverride["PRICE_DISPLAY_OVERRIDE_NONE"] = 0] = "PRICE_DISPLAY_OVERRIDE_NONE";
  PriceDisplayOverride[PriceDisplayOverride["PRICE_DISPLAY_OVERRIDE_CONTACT_SALES"] = 1] = "PRICE_DISPLAY_OVERRIDE_CONTACT_SALES";
  PriceDisplayOverride[PriceDisplayOverride["PRICE_DISPLAY_OVERRIDE_STARTING_AT"] = 2] = "PRICE_DISPLAY_OVERRIDE_STARTING_AT";
  return PriceDisplayOverride;
}(PriceDisplayOverride || {});
var UnitBillingFrequency = /*#__PURE__*/function (UnitBillingFrequency) {
  UnitBillingFrequency[UnitBillingFrequency["UNIT_BILLING_FREQUENCY_INVALID"] = 0] = "UNIT_BILLING_FREQUENCY_INVALID";
  UnitBillingFrequency[UnitBillingFrequency["UNIT_BILLING_FREQUENCY_MONTHLY"] = 1] = "UNIT_BILLING_FREQUENCY_MONTHLY";
  UnitBillingFrequency[UnitBillingFrequency["UNIT_BILLING_FREQUENCY_YEARLY"] = 2] = "UNIT_BILLING_FREQUENCY_YEARLY";
  UnitBillingFrequency[UnitBillingFrequency["UNIT_BILLING_FREQUENCY_ONETIME"] = 3] = "UNIT_BILLING_FREQUENCY_ONETIME";
  return UnitBillingFrequency;
}(UnitBillingFrequency || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AuxiliaryDataFieldType = /*#__PURE__*/function (AuxiliaryDataFieldType) {
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INVALID"] = 0] = "AUXILIARY_DATA_FIELD_TYPE_INVALID";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_STRING"] = 1] = "AUXILIARY_DATA_FIELD_TYPE_STRING";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INTEGER"] = 2] = "AUXILIARY_DATA_FIELD_TYPE_INTEGER";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DATE"] = 3] = "AUXILIARY_DATA_FIELD_TYPE_DATE";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DROPDOWN"] = 4] = "AUXILIARY_DATA_FIELD_TYPE_DROPDOWN";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_CURRENCY"] = 5] = "AUXILIARY_DATA_FIELD_TYPE_CURRENCY";
  return AuxiliaryDataFieldType;
}(AuxiliaryDataFieldType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ReleaseType = /*#__PURE__*/function (ReleaseType) {
  ReleaseType[ReleaseType["RELEASE_TYPE_DRAFT"] = 0] = "RELEASE_TYPE_DRAFT";
  ReleaseType[ReleaseType["RELEASE_TYPE_PUBLISHED"] = 1] = "RELEASE_TYPE_PUBLISHED";
  return ReleaseType;
}(ReleaseType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AppReportingCodeOverrideType = /*#__PURE__*/function (AppReportingCodeOverrideType) {
  AppReportingCodeOverrideType[AppReportingCodeOverrideType["APP_REPORTING_CODE_OVERRIDE_TYPE_INVALID"] = 0] = "APP_REPORTING_CODE_OVERRIDE_TYPE_INVALID";
  AppReportingCodeOverrideType[AppReportingCodeOverrideType["APP_REPORTING_CODE_OVERRIDE_TYPE_VENDASTA_CORE_APPS"] = 1] = "APP_REPORTING_CODE_OVERRIDE_TYPE_VENDASTA_CORE_APPS";
  AppReportingCodeOverrideType[AppReportingCodeOverrideType["APP_REPORTING_CODE_OVERRIDE_TYPE_VENDASTA_DIGITAL_ADS_APPS"] = 2] = "APP_REPORTING_CODE_OVERRIDE_TYPE_VENDASTA_DIGITAL_ADS_APPS";
  AppReportingCodeOverrideType[AppReportingCodeOverrideType["APP_REPORTING_CODE_OVERRIDE_TYPE_VENDASTA_WEBSITES_APPS"] = 3] = "APP_REPORTING_CODE_OVERRIDE_TYPE_VENDASTA_WEBSITES_APPS";
  AppReportingCodeOverrideType[AppReportingCodeOverrideType["APP_REPORTING_CODE_OVERRIDE_TYPE_MANAGEMENT_FEE_DIGITAL_ADS_APPS"] = 4] = "APP_REPORTING_CODE_OVERRIDE_TYPE_MANAGEMENT_FEE_DIGITAL_ADS_APPS";
  return AppReportingCodeOverrideType;
}(AppReportingCodeOverrideType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$j(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActivationInformation {
  static fromProto(proto) {
    let m = new ActivationInformation();
    m = Object.assign(m, proto);
    if (proto.requiredBusinessData) {
      m.requiredBusinessData = RequiredBusinessData.fromProto(proto.requiredBusinessData);
    }
    if (proto.suspended) {
      m.suspended = new Date(proto.suspended);
    }
    if (proto.countryRestrictions) {
      m.countryRestrictions = PermissionLists.fromProto(proto.countryRestrictions);
    }
    if (proto.appRestrictions) {
      m.appRestrictions = AppRestrictions.fromProto(proto.appRestrictions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderFormEnabled !== 'undefined') {
      toReturn['orderFormEnabled'] = this.orderFormEnabled;
    }
    if (typeof this.multipleActivationsEnabled !== 'undefined') {
      toReturn['multipleActivationsEnabled'] = this.multipleActivationsEnabled;
    }
    if (typeof this.activationSpecificUrlEnabled !== 'undefined') {
      toReturn['activationSpecificUrlEnabled'] = this.activationSpecificUrlEnabled;
    }
    if (typeof this.separateOrderForms !== 'undefined') {
      toReturn['separateOrderForms'] = this.separateOrderForms;
    }
    if (typeof this.requiredBusinessData !== 'undefined' && this.requiredBusinessData !== null) {
      toReturn['requiredBusinessData'] = 'toApiJson' in this.requiredBusinessData ? this.requiredBusinessData.toApiJson() : this.requiredBusinessData;
    }
    if (typeof this.suspended !== 'undefined' && this.suspended !== null) {
      toReturn['suspended'] = 'toApiJson' in this.suspended ? this.suspended.toApiJson() : this.suspended;
    }
    if (typeof this.countryRestrictions !== 'undefined' && this.countryRestrictions !== null) {
      toReturn['countryRestrictions'] = 'toApiJson' in this.countryRestrictions ? this.countryRestrictions.toApiJson() : this.countryRestrictions;
    }
    if (typeof this.appRestrictions !== 'undefined' && this.appRestrictions !== null) {
      toReturn['appRestrictions'] = 'toApiJson' in this.appRestrictions ? this.appRestrictions.toApiJson() : this.appRestrictions;
    }
    return toReturn;
  }
}
class App {
  static fromProto(proto) {
    let m = new App();
    m = Object.assign(m, proto);
    if (proto.key) {
      m.key = AppKey.fromProto(proto.key);
    }
    if (proto.sharedMarketingInformation) {
      m.sharedMarketingInformation = SharedMarketingInformation.fromProto(proto.sharedMarketingInformation);
    }
    if (proto.endUserMarketingInformation) {
      m.endUserMarketingInformation = EndUserMarketingInformation.fromProto(proto.endUserMarketingInformation);
    }
    if (proto.parentRequirements) {
      m.parentRequirements = RequiredParent.fromProto(proto.parentRequirements);
    }
    if (proto.ssoIntegration) {
      m.ssoIntegration = SSOIntegration.fromProto(proto.ssoIntegration);
    }
    if (proto.activationInformation) {
      m.activationInformation = ActivationInformation.fromProto(proto.activationInformation);
    }
    if (proto.trialConfiguration) {
      m.trialConfiguration = TrialConfiguration.fromProto(proto.trialConfiguration);
    }
    if (proto.basicIntegration) {
      m.basicIntegration = BasicIntegration.fromProto(proto.basicIntegration);
    }
    if (proto.editionInformation) {
      m.editionInformation = EditionInformation.fromProto(proto.editionInformation);
    }
    if (proto.externalIdentifiers) {
      m.externalIdentifiers = ExternalIdentifiers.fromProto(proto.externalIdentifiers);
    }
    if (proto.price) {
      m.price = Price.fromProto(proto.price);
    }
    if (proto.appType) {
      m.appType = enumStringToValue$j(AppType, proto.appType);
    }
    if (proto.appLevelAdminDashboardEnabled) {
      m.appLevelAdminDashboardEnabled = AppLevelAdminDashboardEnabled.fromProto(proto.appLevelAdminDashboardEnabled);
    }
    if (proto.childApps) {
      m.childApps = proto.childApps.map(ChildApp.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined' && this.key !== null) {
      toReturn['key'] = 'toApiJson' in this.key ? this.key.toApiJson() : this.key;
    }
    if (typeof this.sharedMarketingInformation !== 'undefined' && this.sharedMarketingInformation !== null) {
      toReturn['sharedMarketingInformation'] = 'toApiJson' in this.sharedMarketingInformation ? this.sharedMarketingInformation.toApiJson() : this.sharedMarketingInformation;
    }
    if (typeof this.endUserMarketingInformation !== 'undefined' && this.endUserMarketingInformation !== null) {
      toReturn['endUserMarketingInformation'] = 'toApiJson' in this.endUserMarketingInformation ? this.endUserMarketingInformation.toApiJson() : this.endUserMarketingInformation;
    }
    if (typeof this.parentRequirements !== 'undefined' && this.parentRequirements !== null) {
      toReturn['parentRequirements'] = 'toApiJson' in this.parentRequirements ? this.parentRequirements.toApiJson() : this.parentRequirements;
    }
    if (typeof this.ssoIntegration !== 'undefined' && this.ssoIntegration !== null) {
      toReturn['ssoIntegration'] = 'toApiJson' in this.ssoIntegration ? this.ssoIntegration.toApiJson() : this.ssoIntegration;
    }
    if (typeof this.activationInformation !== 'undefined' && this.activationInformation !== null) {
      toReturn['activationInformation'] = 'toApiJson' in this.activationInformation ? this.activationInformation.toApiJson() : this.activationInformation;
    }
    if (typeof this.trialConfiguration !== 'undefined' && this.trialConfiguration !== null) {
      toReturn['trialConfiguration'] = 'toApiJson' in this.trialConfiguration ? this.trialConfiguration.toApiJson() : this.trialConfiguration;
    }
    if (typeof this.basicIntegration !== 'undefined' && this.basicIntegration !== null) {
      toReturn['basicIntegration'] = 'toApiJson' in this.basicIntegration ? this.basicIntegration.toApiJson() : this.basicIntegration;
    }
    if (typeof this.editionInformation !== 'undefined' && this.editionInformation !== null) {
      toReturn['editionInformation'] = 'toApiJson' in this.editionInformation ? this.editionInformation.toApiJson() : this.editionInformation;
    }
    if (typeof this.externalIdentifiers !== 'undefined' && this.externalIdentifiers !== null) {
      toReturn['externalIdentifiers'] = 'toApiJson' in this.externalIdentifiers ? this.externalIdentifiers.toApiJson() : this.externalIdentifiers;
    }
    if (typeof this.price !== 'undefined' && this.price !== null) {
      toReturn['price'] = 'toApiJson' in this.price ? this.price.toApiJson() : this.price;
    }
    if (typeof this.appType !== 'undefined') {
      toReturn['appType'] = this.appType;
    }
    if (typeof this.appLevelAdminDashboardEnabled !== 'undefined' && this.appLevelAdminDashboardEnabled !== null) {
      toReturn['appLevelAdminDashboardEnabled'] = 'toApiJson' in this.appLevelAdminDashboardEnabled ? this.appLevelAdminDashboardEnabled.toApiJson() : this.appLevelAdminDashboardEnabled;
    }
    if (typeof this.childApps !== 'undefined' && this.childApps !== null) {
      toReturn['childApps'] = 'toApiJson' in this.childApps ? this.childApps.toApiJson() : this.childApps;
    }
    return toReturn;
  }
}
class AppKey {
  static fromProto(proto) {
    let m = new AppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class AppLevelAdminDashboardEnabled {
  static fromProto(proto) {
    let m = new AppLevelAdminDashboardEnabled();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appLevelAdminDashboardEnabledForPartnerCenter !== 'undefined') {
      toReturn['appLevelAdminDashboardEnabledForPartnerCenter'] = this.appLevelAdminDashboardEnabledForPartnerCenter;
    }
    return toReturn;
  }
}
class AppRestrictions {
  static fromProto(proto) {
    let m = new AppRestrictions();
    m = Object.assign(m, proto);
    if (proto.requiredEditionIds) {
      m.requiredEditionIds = proto.requiredEditionIds.map(EditionIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requiredAppIds !== 'undefined') {
      toReturn['requiredAppIds'] = this.requiredAppIds;
    }
    if (typeof this.requiredEditionIds !== 'undefined' && this.requiredEditionIds !== null) {
      toReturn['requiredEditionIds'] = 'toApiJson' in this.requiredEditionIds ? this.requiredEditionIds.toApiJson() : this.requiredEditionIds;
    }
    return toReturn;
  }
}
class BasicIntegration {
  static fromProto(proto) {
    let m = new BasicIntegration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationUrl !== 'undefined') {
      toReturn['applicationUrl'] = this.applicationUrl;
    }
    if (typeof this.allowWhiteLabeling !== 'undefined') {
      toReturn['allowWhiteLabeling'] = this.allowWhiteLabeling;
    }
    if (typeof this.appLevelHasAdminDashboard !== 'undefined') {
      toReturn['appLevelHasAdminDashboard'] = this.appLevelHasAdminDashboard;
    }
    if (typeof this.hideFromClientDashboard !== 'undefined') {
      toReturn['hideFromClientDashboard'] = this.hideFromClientDashboard;
    }
    return toReturn;
  }
}
class ChildApp {
  static fromProto(proto) {
    let m = new ChildApp();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class RequiredParentDetails {
  static fromProto(proto) {
    let m = new RequiredParentDetails();
    m = Object.assign(m, proto);
    if (proto.key) {
      m.key = AppKey.fromProto(proto.key);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined' && this.key !== null) {
      toReturn['key'] = 'toApiJson' in this.key ? this.key.toApiJson() : this.key;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    return toReturn;
  }
}
class Edition {
  static fromProto(proto) {
    let m = new Edition();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = AppKey.fromProto(proto.appKey);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    return toReturn;
  }
}
class EditionIdentifier {
  static fromProto(proto) {
    let m = new EditionIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class EditionInformation {
  static fromProto(proto) {
    let m = new EditionInformation();
    m = Object.assign(m, proto);
    if (proto.editions) {
      m.editions = proto.editions.map(Edition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.editions !== 'undefined' && this.editions !== null) {
      toReturn['editions'] = 'toApiJson' in this.editions ? this.editions.toApiJson() : this.editions;
    }
    if (typeof this.usesEditions !== 'undefined') {
      toReturn['usesEditions'] = this.usesEditions;
    }
    return toReturn;
  }
}
class EndUserMarketingInformation {
  static fromProto(proto) {
    let m = new EndUserMarketingInformation();
    m = Object.assign(m, proto);
    if (proto.faqs) {
      m.faqs = proto.faqs.map(FrequentlyAskedQuestions.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.keySellingPoints !== 'undefined') {
      toReturn['keySellingPoints'] = this.keySellingPoints;
    }
    if (typeof this.faqs !== 'undefined' && this.faqs !== null) {
      toReturn['faqs'] = 'toApiJson' in this.faqs ? this.faqs.toApiJson() : this.faqs;
    }
    if (typeof this.fileUrls !== 'undefined') {
      toReturn['fileUrls'] = this.fileUrls;
    }
    if (typeof this.screenshotUrls !== 'undefined') {
      toReturn['screenshotUrls'] = this.screenshotUrls;
    }
    if (typeof this.needHelp !== 'undefined') {
      toReturn['needHelp'] = this.needHelp;
    }
    if (typeof this.videos !== 'undefined') {
      toReturn['videos'] = this.videos;
    }
    return toReturn;
  }
}
class ExternalIdentifiers {
  static fromProto(proto) {
    let m = new ExternalIdentifiers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    return toReturn;
  }
}
class FrequentlyAskedQuestions {
  static fromProto(proto) {
    let m = new FrequentlyAskedQuestions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.question !== 'undefined') {
      toReturn['question'] = this.question;
    }
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    return toReturn;
  }
}
class PermissionLists {
  static fromProto(proto) {
    let m = new PermissionLists();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.whitelist !== 'undefined') {
      toReturn['whitelist'] = this.whitelist;
    }
    if (typeof this.blacklist !== 'undefined') {
      toReturn['blacklist'] = this.blacklist;
    }
    return toReturn;
  }
}
class Price {
  static fromProto(proto) {
    let m = new Price();
    m = Object.assign(m, proto);
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.usesCustomPricing !== 'undefined') {
      toReturn['usesCustomPricing'] = this.usesCustomPricing;
    }
    return toReturn;
  }
}
class RequiredBusinessData {
  static fromProto(proto) {
    let m = new RequiredBusinessData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hours !== 'undefined') {
      toReturn['hours'] = this.hours;
    }
    if (typeof this.descriptionLong !== 'undefined') {
      toReturn['descriptionLong'] = this.descriptionLong;
    }
    if (typeof this.descriptionShort !== 'undefined') {
      toReturn['descriptionShort'] = this.descriptionShort;
    }
    if (typeof this.services !== 'undefined') {
      toReturn['services'] = this.services;
    }
    if (typeof this.brands !== 'undefined') {
      toReturn['brands'] = this.brands;
    }
    return toReturn;
  }
}
class RequiredParent {
  static fromProto(proto) {
    let m = new RequiredParent();
    m = Object.assign(m, proto);
    if (proto.parentDetails) {
      m.parentDetails = RequiredParentDetails.fromProto(proto.parentDetails);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.parentDetails !== 'undefined' && this.parentDetails !== null) {
      toReturn['parentDetails'] = 'toApiJson' in this.parentDetails ? this.parentDetails.toApiJson() : this.parentDetails;
    }
    return toReturn;
  }
}
class SSOIntegration {
  static fromProto(proto) {
    let m = new SSOIntegration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    return toReturn;
  }
}
class SharedMarketingInformation {
  static fromProto(proto) {
    let m = new SharedMarketingInformation();
    m = Object.assign(m, proto);
    if (proto.lmiCategories) {
      m.lmiCategories = proto.lmiCategories.map(v => enumStringToValue$j(LmiCategory, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.editionName !== 'undefined') {
      toReturn['editionName'] = this.editionName;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.bannerImageUrl !== 'undefined') {
      toReturn['bannerImageUrl'] = this.bannerImageUrl;
    }
    if (typeof this.lmiCategories !== 'undefined') {
      toReturn['lmiCategories'] = this.lmiCategories;
    }
    return toReturn;
  }
}
class TrialConfiguration {
  static fromProto(proto) {
    let m = new TrialConfiguration();
    m = Object.assign(m, proto);
    if (proto.endOfTrialAction) {
      m.endOfTrialAction = enumStringToValue$j(EndOfTrialActions, proto.endOfTrialAction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.trialEnabled !== 'undefined') {
      toReturn['trialEnabled'] = this.trialEnabled;
    }
    if (typeof this.trialDuration !== 'undefined') {
      toReturn['trialDuration'] = this.trialDuration;
    }
    if (typeof this.endOfTrialAction !== 'undefined') {
      toReturn['endOfTrialAction'] = this.endOfTrialAction;
    }
    return toReturn;
  }
}
function enumStringToValue$i(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppLevelAdminDashboard {
  static fromProto(proto) {
    let m = new AppLevelAdminDashboard();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.allowSelfServeForPartner !== 'undefined') {
      toReturn['allowSelfServeForPartner'] = this.allowSelfServeForPartner;
    }
    return toReturn;
  }
}
class AppSettings {
  static fromProto(proto) {
    let m = new AppSettings();
    m = Object.assign(m, proto);
    if (proto.autoActivation) {
      m.autoActivation = AutoActivation.fromProto(proto.autoActivation);
    }
    if (proto.editionChange) {
      m.editionChange = EditionChange.fromProto(proto.editionChange);
    }
    if (proto.trial) {
      m.trial = Trial.fromProto(proto.trial);
    }
    if (proto.branding) {
      m.branding = Branding.fromProto(proto.branding);
    }
    if (proto.appLevelAdminDashboard) {
      m.appLevelAdminDashboard = AppLevelAdminDashboard.fromProto(proto.appLevelAdminDashboard);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.autoActivation !== 'undefined' && this.autoActivation !== null) {
      toReturn['autoActivation'] = 'toApiJson' in this.autoActivation ? this.autoActivation.toApiJson() : this.autoActivation;
    }
    if (typeof this.editionChange !== 'undefined' && this.editionChange !== null) {
      toReturn['editionChange'] = 'toApiJson' in this.editionChange ? this.editionChange.toApiJson() : this.editionChange;
    }
    if (typeof this.trial !== 'undefined' && this.trial !== null) {
      toReturn['trial'] = 'toApiJson' in this.trial ? this.trial.toApiJson() : this.trial;
    }
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn['branding'] = 'toApiJson' in this.branding ? this.branding.toApiJson() : this.branding;
    }
    if (typeof this.appLevelAdminDashboard !== 'undefined' && this.appLevelAdminDashboard !== null) {
      toReturn['appLevelAdminDashboard'] = 'toApiJson' in this.appLevelAdminDashboard ? this.appLevelAdminDashboard.toApiJson() : this.appLevelAdminDashboard;
    }
    return toReturn;
  }
}
class AutoActivation {
  static fromProto(proto) {
    let m = new AutoActivation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.autoActivateByDefault !== 'undefined') {
      toReturn['autoActivateByDefault'] = this.autoActivateByDefault;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class Branding {
  static fromProto(proto) {
    let m = new Branding();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    return toReturn;
  }
}
class EditionChange {
  static fromProto(proto) {
    let m = new EditionChange();
    m = Object.assign(m, proto);
    if (proto.editionUpgradeAction) {
      m.editionUpgradeAction = enumStringToValue$i(EditionUpgradeAction, proto.editionUpgradeAction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.editionUpgradeAction !== 'undefined') {
      toReturn['editionUpgradeAction'] = this.editionUpgradeAction;
    }
    if (typeof this.customUpgradePackageIds !== 'undefined') {
      toReturn['customUpgradePackageIds'] = this.customUpgradePackageIds;
    }
    if (typeof this.priceReferencePackageId !== 'undefined') {
      toReturn['priceReferencePackageId'] = this.priceReferencePackageId;
    }
    if (typeof this.hideUpgradeCta !== 'undefined') {
      toReturn['hideUpgradeCta'] = this.hideUpgradeCta;
    }
    return toReturn;
  }
}
class Trial {
  static fromProto(proto) {
    let m = new Trial();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.allowSelfServe !== 'undefined') {
      toReturn['allowSelfServe'] = this.allowSelfServe;
    }
    return toReturn;
  }
}
function enumStringToValue$h(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class UpgradeDialogContent {
  static fromProto(proto) {
    let m = new UpgradeDialogContent();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.titleText !== 'undefined') {
      toReturn['titleText'] = this.titleText;
    }
    if (typeof this.sellingPoints !== 'undefined') {
      toReturn['sellingPoints'] = this.sellingPoints;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.buttonText !== 'undefined') {
      toReturn['buttonText'] = this.buttonText;
    }
    if (typeof this.imageFileName !== 'undefined') {
      toReturn['imageFileName'] = this.imageFileName;
    }
    return toReturn;
  }
}
function enumStringToValue$g(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
class MCPOptions {
  static fromProto(proto) {
    let m = new MCPOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serverId !== 'undefined') {
      toReturn['serverId'] = this.serverId;
    }
    return toReturn;
  }
}
function enumStringToValue$f(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppKeyWithQuantity {
  static fromProto(proto) {
    let m = new AppKeyWithQuantity();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = AppKey.fromProto(proto.appKey);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class GetAppSettingsRequest {
  static fromProto(proto) {
    let m = new GetAppSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.disableFallback !== 'undefined') {
      toReturn['disableFallback'] = this.disableFallback;
    }
    return toReturn;
  }
}
class GetAppSettingsResponse {
  static fromProto(proto) {
    let m = new GetAppSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.appSettings) {
      m.appSettings = AppSettings.fromProto(proto.appSettings);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appSettings !== 'undefined' && this.appSettings !== null) {
      toReturn['appSettings'] = 'toApiJson' in this.appSettings ? this.appSettings.toApiJson() : this.appSettings;
    }
    return toReturn;
  }
}
class GetMultiAppRequest {
  static fromProto(proto) {
    let m = new GetMultiAppRequest();
    m = Object.assign(m, proto);
    if (proto.projectionFilter) {
      m.projectionFilter = FieldMask.fromProto(proto.projectionFilter);
    }
    if (proto.appKeys) {
      m.appKeys = proto.appKeys.map(AppKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    if (typeof this.appKeys !== 'undefined' && this.appKeys !== null) {
      toReturn['appKeys'] = 'toApiJson' in this.appKeys ? this.appKeys.toApiJson() : this.appKeys;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.includeNotEnabled !== 'undefined') {
      toReturn['includeNotEnabled'] = this.includeNotEnabled;
    }
    return toReturn;
  }
}
class GetMultiAppResponse {
  static fromProto(proto) {
    let m = new GetMultiAppResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(App.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    return toReturn;
  }
}
class GetPurchaseLinkRequest {
  static fromProto(proto) {
    let m = new GetPurchaseLinkRequest();
    m = Object.assign(m, proto);
    if (proto.appKeysWithQuantity) {
      m.appKeysWithQuantity = proto.appKeysWithQuantity.map(AppKeyWithQuantity.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appKeysWithQuantity !== 'undefined' && this.appKeysWithQuantity !== null) {
      toReturn['appKeysWithQuantity'] = 'toApiJson' in this.appKeysWithQuantity ? this.appKeysWithQuantity.toApiJson() : this.appKeysWithQuantity;
    }
    if (typeof this.purchaseAcceptedNextUrl !== 'undefined') {
      toReturn['purchaseAcceptedNextUrl'] = this.purchaseAcceptedNextUrl;
    }
    if (typeof this.purchaseDeclinedNextUrl !== 'undefined') {
      toReturn['purchaseDeclinedNextUrl'] = this.purchaseDeclinedNextUrl;
    }
    return toReturn;
  }
}
class GetPurchaseLinkResponse {
  static fromProto(proto) {
    let m = new GetPurchaseLinkResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchaseLink !== 'undefined') {
      toReturn['purchaseLink'] = this.purchaseLink;
    }
    if (typeof this.purchaseAllowed !== 'undefined') {
      toReturn['purchaseAllowed'] = this.purchaseAllowed;
    }
    return toReturn;
  }
}
class GetUpgradeDialogContentRequest {
  static fromProto(proto) {
    let m = new GetUpgradeDialogContentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class GetUpgradeDialogContentResponse {
  static fromProto(proto) {
    let m = new GetUpgradeDialogContentResponse();
    m = Object.assign(m, proto);
    if (proto.upgradeDialogContent) {
      m.upgradeDialogContent = UpgradeDialogContent.fromProto(proto.upgradeDialogContent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.upgradeDialogContent !== 'undefined' && this.upgradeDialogContent !== null) {
      toReturn['upgradeDialogContent'] = 'toApiJson' in this.upgradeDialogContent ? this.upgradeDialogContent.toApiJson() : this.upgradeDialogContent;
    }
    return toReturn;
  }
}
class ListAppSettingsRequest {
  static fromProto(proto) {
    let m = new ListAppSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListAppSettingsResponse {
  static fromProto(proto) {
    let m = new ListAppSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.appSettings) {
      m.appSettings = proto.appSettings.map(AppSettings.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appSettings !== 'undefined' && this.appSettings !== null) {
      toReturn['appSettings'] = 'toApiJson' in this.appSettings ? this.appSettings.toApiJson() : this.appSettings;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListPartnerEnabledAppsRequestListAppsFilter {
  static fromProto(proto) {
    let m = new ListPartnerEnabledAppsRequestListAppsFilter();
    m = Object.assign(m, proto);
    if (proto.appType) {
      m.appType = enumStringToValue$e(AppType, proto.appType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appType !== 'undefined') {
      toReturn['appType'] = this.appType;
    }
    if (typeof this.filterTerm !== 'undefined') {
      toReturn['filterTerm'] = this.filterTerm;
    }
    return toReturn;
  }
}
class ListPartnerEnabledAppsRequest {
  static fromProto(proto) {
    let m = new ListPartnerEnabledAppsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filter) {
      m.filter = ListPartnerEnabledAppsRequestListAppsFilter.fromProto(proto.filter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    return toReturn;
  }
}
class ListPartnerEnabledAppsResponse {
  static fromProto(proto) {
    let m = new ListPartnerEnabledAppsResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(App.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ProductSuggestion {
  static fromProto(proto) {
    let m = new ProductSuggestion();
    m = Object.assign(m, proto);
    if (proto.reason) {
      m.reason = enumStringToValue$e(SuggestionReason, proto.reason);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.productWebsiteUrl !== 'undefined') {
      toReturn['productWebsiteUrl'] = this.productWebsiteUrl;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.otherReasonText !== 'undefined') {
      toReturn['otherReasonText'] = this.otherReasonText;
    }
    return toReturn;
  }
}
class ReplaceAppSettingsRequest {
  static fromProto(proto) {
    let m = new ReplaceAppSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.autoActivation) {
      m.autoActivation = AutoActivation.fromProto(proto.autoActivation);
    }
    if (proto.editionChange) {
      m.editionChange = EditionChange.fromProto(proto.editionChange);
    }
    if (proto.trial) {
      m.trial = Trial.fromProto(proto.trial);
    }
    if (proto.branding) {
      m.branding = Branding.fromProto(proto.branding);
    }
    if (proto.appLevelAdminDashboard) {
      m.appLevelAdminDashboard = AppLevelAdminDashboard.fromProto(proto.appLevelAdminDashboard);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.autoActivation !== 'undefined' && this.autoActivation !== null) {
      toReturn['autoActivation'] = 'toApiJson' in this.autoActivation ? this.autoActivation.toApiJson() : this.autoActivation;
    }
    if (typeof this.editionChange !== 'undefined' && this.editionChange !== null) {
      toReturn['editionChange'] = 'toApiJson' in this.editionChange ? this.editionChange.toApiJson() : this.editionChange;
    }
    if (typeof this.trial !== 'undefined' && this.trial !== null) {
      toReturn['trial'] = 'toApiJson' in this.trial ? this.trial.toApiJson() : this.trial;
    }
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn['branding'] = 'toApiJson' in this.branding ? this.branding.toApiJson() : this.branding;
    }
    if (typeof this.appLevelAdminDashboard !== 'undefined' && this.appLevelAdminDashboard !== null) {
      toReturn['appLevelAdminDashboard'] = 'toApiJson' in this.appLevelAdminDashboard ? this.appLevelAdminDashboard.toApiJson() : this.appLevelAdminDashboard;
    }
    return toReturn;
  }
}
class ReplaceAppSettingsResponse {
  static fromProto(proto) {
    let m = new ReplaceAppSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.appSettings) {
      m.appSettings = AppSettings.fromProto(proto.appSettings);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appSettings !== 'undefined' && this.appSettings !== null) {
      toReturn['appSettings'] = 'toApiJson' in this.appSettings ? this.appSettings.toApiJson() : this.appSettings;
    }
    return toReturn;
  }
}
class ReplaceUpgradeDialogContentRequest {
  static fromProto(proto) {
    let m = new ReplaceUpgradeDialogContentRequest();
    m = Object.assign(m, proto);
    if (proto.upgradeDialogContent) {
      m.upgradeDialogContent = UpgradeDialogContent.fromProto(proto.upgradeDialogContent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.upgradeDialogContent !== 'undefined' && this.upgradeDialogContent !== null) {
      toReturn['upgradeDialogContent'] = 'toApiJson' in this.upgradeDialogContent ? this.upgradeDialogContent.toApiJson() : this.upgradeDialogContent;
    }
    return toReturn;
  }
}
class SuggestProductRequest {
  static fromProto(proto) {
    let m = new SuggestProductRequest();
    m = Object.assign(m, proto);
    if (proto.productSuggestion) {
      m.productSuggestion = ProductSuggestion.fromProto(proto.productSuggestion);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productSuggestion !== 'undefined' && this.productSuggestion !== null) {
      toReturn['productSuggestion'] = 'toApiJson' in this.productSuggestion ? this.productSuggestion.toApiJson() : this.productSuggestion;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppTag {
  static fromProto(proto) {
    let m = new AppTag();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.kind !== 'undefined') {
      toReturn['kind'] = this.kind;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class GetMultiAppDataRequest {
  static fromProto(proto) {
    let m = new GetMultiAppDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class GetMultiAppDataResponse {
  static fromProto(proto) {
    let m = new GetMultiAppDataResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(MarketplaceApp.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    return toReturn;
  }
}
class KindValues {
  static fromProto(proto) {
    let m = new KindValues();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.kind !== 'undefined') {
      toReturn['kind'] = this.kind;
    }
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class ListAppIDsByMultiTagRequest {
  static fromProto(proto) {
    let m = new ListAppIDsByMultiTagRequest();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListAppIDsByMultiTagResponse {
  static fromProto(proto) {
    let m = new ListAppIDsByMultiTagResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListByMultiTagRequest {
  static fromProto(proto) {
    let m = new ListByMultiTagRequest();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(ScopedTag.fromProto);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListByMultiTagResponse {
  static fromProto(proto) {
    let m = new ListByMultiTagResponse();
    m = Object.assign(m, proto);
    if (proto.appTags) {
      m.appTags = proto.appTags.map(AppTag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appTags !== 'undefined' && this.appTags !== null) {
      toReturn['appTags'] = 'toApiJson' in this.appTags ? this.appTags.toApiJson() : this.appTags;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListValuesByMultiKindRequest {
  static fromProto(proto) {
    let m = new ListValuesByMultiKindRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.kind !== 'undefined') {
      toReturn['kind'] = this.kind;
    }
    return toReturn;
  }
}
class ListValuesByMultiKindResponse {
  static fromProto(proto) {
    let m = new ListValuesByMultiKindResponse();
    m = Object.assign(m, proto);
    if (proto.tagValues) {
      m.tagValues = proto.tagValues.map(KindValues.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.tagValues !== 'undefined' && this.tagValues !== null) {
      toReturn['tagValues'] = 'toApiJson' in this.tagValues ? this.tagValues.toApiJson() : this.tagValues;
    }
    return toReturn;
  }
}
class MarketplaceApp {
  static fromProto(proto) {
    let m = new MarketplaceApp();
    m = Object.assign(m, proto);
    if (proto.appData) {
      m.appData = proto.appData.map(KindValues.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.appData !== 'undefined' && this.appData !== null) {
      toReturn['appData'] = 'toApiJson' in this.appData ? this.appData.toApiJson() : this.appData;
    }
    return toReturn;
  }
}
class ScopedTag {
  static fromProto(proto) {
    let m = new ScopedTag();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.kind !== 'undefined') {
      toReturn['kind'] = this.kind;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    return toReturn;
  }
}
class Tag {
  static fromProto(proto) {
    let m = new Tag();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.kind !== 'undefined') {
      toReturn['kind'] = this.kind;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class TagAppsRequest {
  static fromProto(proto) {
    let m = new TagAppsRequest();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(ScopedTag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class UntagAppsRequest {
  static fromProto(proto) {
    let m = new UntagAppsRequest();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(ScopedTag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActivatableItemSummary {
  static fromProto(proto) {
    let m = new ActivatableItemSummary();
    m = Object.assign(m, proto);
    if (proto.requiredItems) {
      m.requiredItems = proto.requiredItems.map(RequiredItem.fromProto);
    }
    if (proto.itemType) {
      m.itemType = enumStringToValue$c(ItemType, proto.itemType);
    }
    if (proto.deliveryMethod) {
      m.deliveryMethod = enumStringToValue$c(DeliveryMethod, proto.deliveryMethod);
    }
    if (proto.enabledDate) {
      m.enabledDate = new Date(proto.enabledDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.defaultName !== 'undefined') {
      toReturn['defaultName'] = this.defaultName;
    }
    if (typeof this.sellerWhitelabelName !== 'undefined') {
      toReturn['sellerWhitelabelName'] = this.sellerWhitelabelName;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.sellerWhitelabelIconUrl !== 'undefined') {
      toReturn['sellerWhitelabelIconUrl'] = this.sellerWhitelabelIconUrl;
    }
    if (typeof this.isSuspended !== 'undefined') {
      toReturn['isSuspended'] = this.isSuspended;
    }
    if (typeof this.isMultiactivatable !== 'undefined') {
      toReturn['isMultiactivatable'] = this.isMultiactivatable;
    }
    if (typeof this.requiredCountries !== 'undefined') {
      toReturn['requiredCountries'] = this.requiredCountries;
    }
    if (typeof this.requiredItems !== 'undefined' && this.requiredItems !== null) {
      toReturn['requiredItems'] = 'toApiJson' in this.requiredItems ? this.requiredItems.toApiJson() : this.requiredItems;
    }
    if (typeof this.ownerName !== 'undefined') {
      toReturn['ownerName'] = this.ownerName;
    }
    if (typeof this.itemType !== 'undefined') {
      toReturn['itemType'] = this.itemType;
    }
    if (typeof this.deliveryMethod !== 'undefined') {
      toReturn['deliveryMethod'] = this.deliveryMethod;
    }
    if (typeof this.enabledDate !== 'undefined' && this.enabledDate !== null) {
      toReturn['enabledDate'] = 'toApiJson' in this.enabledDate ? this.enabledDate.toApiJson() : this.enabledDate;
    }
    if (typeof this.categories !== 'undefined') {
      toReturn['categories'] = this.categories;
    }
    if (typeof this.usesEditions !== 'undefined') {
      toReturn['usesEditions'] = this.usesEditions;
    }
    return toReturn;
  }
}
class Item {
  static fromProto(proto) {
    let m = new Item();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class RequiredItem {
  static fromProto(proto) {
    let m = new RequiredItem();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DependentItems {
  static fromProto(proto) {
    let m = new DependentItems();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    return toReturn;
  }
}
class GetMultiDependentItemsResponseDependentItemsEntry {
  static fromProto(proto) {
    let m = new GetMultiDependentItemsResponseDependentItemsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = DependentItems.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class EditionRequirement {
  static fromProto(proto) {
    let m = new EditionRequirement();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.editionRequired !== 'undefined') {
      toReturn['editionRequired'] = this.editionRequired;
    }
    return toReturn;
  }
}
class GetMultiDependentItemsRequest {
  static fromProto(proto) {
    let m = new GetMultiDependentItemsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.sellerId !== 'undefined') {
      toReturn['sellerId'] = this.sellerId;
    }
    if (typeof this.storeId !== 'undefined') {
      toReturn['storeId'] = this.storeId;
    }
    return toReturn;
  }
}
class GetMultiDependentItemsResponse {
  static fromProto(proto) {
    let m = new GetMultiDependentItemsResponse();
    m = Object.assign(m, proto);
    if (proto.dependentItems) {
      m.dependentItems = Object.keys(proto.dependentItems).reduce((obj, k) => {
        obj[k] = DependentItems.fromProto(proto.dependentItems[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dependentItems !== 'undefined' && this.dependentItems !== null) {
      toReturn['dependentItems'] = 'toApiJson' in this.dependentItems ? this.dependentItems.toApiJson() : this.dependentItems;
    }
    return toReturn;
  }
}
class ItemIdentifier {
  static fromProto(proto) {
    let m = new ItemIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class ListDependenciesRequest {
  static fromProto(proto) {
    let m = new ListDependenciesRequest();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(ItemIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sellerId !== 'undefined') {
      toReturn['sellerId'] = this.sellerId;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.storeId !== 'undefined') {
      toReturn['storeId'] = this.storeId;
    }
    return toReturn;
  }
}
class ListDependenciesRequiredItem {
  static fromProto(proto) {
    let m = new ListDependenciesRequiredItem();
    m = Object.assign(m, proto);
    if (proto.editionRequirement) {
      m.editionRequirement = EditionRequirement.fromProto(proto.editionRequirement);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.editionRequirement !== 'undefined' && this.editionRequirement !== null) {
      toReturn['editionRequirement'] = 'toApiJson' in this.editionRequirement ? this.editionRequirement.toApiJson() : this.editionRequirement;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    return toReturn;
  }
}
class ListDependenciesRequiredItems {
  static fromProto(proto) {
    let m = new ListDependenciesRequiredItems();
    m = Object.assign(m, proto);
    if (proto.requiredItems) {
      m.requiredItems = proto.requiredItems.map(ListDependenciesRequiredItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requiredItems !== 'undefined' && this.requiredItems !== null) {
      toReturn['requiredItems'] = 'toApiJson' in this.requiredItems ? this.requiredItems.toApiJson() : this.requiredItems;
    }
    return toReturn;
  }
}
class ListDependenciesResponse {
  static fromProto(proto) {
    let m = new ListDependenciesResponse();
    m = Object.assign(m, proto);
    if (proto.missingItems) {
      m.missingItems = Object.keys(proto.missingItems).reduce((obj, k) => {
        obj[k] = ListDependenciesRequiredItems.fromProto(proto.missingItems[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.missingItems !== 'undefined' && this.missingItems !== null) {
      toReturn['missingItems'] = 'toApiJson' in this.missingItems ? this.missingItems.toApiJson() : this.missingItems;
    }
    return toReturn;
  }
}
class ListDependenciesResponseMissingItemsEntry {
  static fromProto(proto) {
    let m = new ListDependenciesResponseMissingItemsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ListDependenciesRequiredItems.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetItemDependencyTreeRequest {
  static fromProto(proto) {
    let m = new GetItemDependencyTreeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.sellerId !== 'undefined') {
      toReturn['sellerId'] = this.sellerId;
    }
    if (typeof this.storeId !== 'undefined') {
      toReturn['storeId'] = this.storeId;
    }
    return toReturn;
  }
}
class GetItemDependencyTreeResponse {
  static fromProto(proto) {
    let m = new GetItemDependencyTreeResponse();
    m = Object.assign(m, proto);
    if (proto.dependencyTree) {
      m.dependencyTree = ItemDependencyNode.fromProto(proto.dependencyTree);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dependencyTree !== 'undefined' && this.dependencyTree !== null) {
      toReturn['dependencyTree'] = 'toApiJson' in this.dependencyTree ? this.dependencyTree.toApiJson() : this.dependencyTree;
    }
    return toReturn;
  }
}
class ItemDependencyNode {
  static fromProto(proto) {
    let m = new ItemDependencyNode();
    m = Object.assign(m, proto);
    if (proto.children) {
      m.children = proto.children.map(ItemDependencyNode.fromProto);
    }
    if (proto.itemType) {
      m.itemType = enumStringToValue$a(ItemType, proto.itemType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.children !== 'undefined' && this.children !== null) {
      toReturn['children'] = 'toApiJson' in this.children ? this.children.toApiJson() : this.children;
    }
    if (typeof this.itemType !== 'undefined') {
      toReturn['itemType'] = this.itemType;
    }
    return toReturn;
  }
}
class ListActivatableItemsFilters {
  static fromProto(proto) {
    let m = new ListActivatableItemsFilters();
    m = Object.assign(m, proto);
    if (proto.itemType) {
      m.itemType = enumStringToValue$a(ItemType, proto.itemType);
    }
    if (proto.hasOrderForm) {
      m.hasOrderForm = enumStringToValue$a(OrderFormFilter, proto.hasOrderForm);
    }
    if (proto.itemTypes) {
      m.itemTypes = proto.itemTypes.map(v => enumStringToValue$a(ItemType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.ownerPartnerId !== 'undefined') {
      toReturn['ownerPartnerId'] = this.ownerPartnerId;
    }
    if (typeof this.includeSuspended !== 'undefined') {
      toReturn['includeSuspended'] = this.includeSuspended;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.itemType !== 'undefined') {
      toReturn['itemType'] = this.itemType;
    }
    if (typeof this.requiredItemId !== 'undefined') {
      toReturn['requiredItemId'] = this.requiredItemId;
    }
    if (typeof this.hasOrderForm !== 'undefined') {
      toReturn['hasOrderForm'] = this.hasOrderForm;
    }
    if (typeof this.itemTypes !== 'undefined') {
      toReturn['itemTypes'] = this.itemTypes;
    }
    return toReturn;
  }
}
class ListActivatableItemsRequest {
  static fromProto(proto) {
    let m = new ListActivatableItemsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortOptions) {
      m.sortOptions = ListActivatableItemsSortOptions.fromProto(proto.sortOptions);
    }
    if (proto.filters) {
      m.filters = ListActivatableItemsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sellerId !== 'undefined') {
      toReturn['sellerId'] = this.sellerId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.storeId !== 'undefined') {
      toReturn['storeId'] = this.storeId;
    }
    return toReturn;
  }
}
class ListActivatableItemsResponse {
  static fromProto(proto) {
    let m = new ListActivatableItemsResponse();
    m = Object.assign(m, proto);
    if (proto.activatableItemSummaries) {
      m.activatableItemSummaries = proto.activatableItemSummaries.map(ActivatableItemSummary.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activatableItemSummaries !== 'undefined' && this.activatableItemSummaries !== null) {
      toReturn['activatableItemSummaries'] = 'toApiJson' in this.activatableItemSummaries ? this.activatableItemSummaries.toApiJson() : this.activatableItemSummaries;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListActivatableItemsSortOptions {
  static fromProto(proto) {
    let m = new ListActivatableItemsSortOptions();
    m = Object.assign(m, proto);
    if (proto.sortField) {
      m.sortField = enumStringToValue$a(ListActivatableItemsSortField, proto.sortField);
    }
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue$a(SortDirection, proto.sortDirection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sortField !== 'undefined') {
      toReturn['sortField'] = this.sortField;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    return toReturn;
  }
}
class ListOwnedItemsFilterOptions {
  static fromProto(proto) {
    let m = new ListOwnedItemsFilterOptions();
    m = Object.assign(m, proto);
    if (proto.appType) {
      m.appType = enumStringToValue$a(ListOwnedItemsFilterOptionsAppType, proto.appType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.appType !== 'undefined') {
      toReturn['appType'] = this.appType;
    }
    return toReturn;
  }
}
class ListOwnedItemsRequest {
  static fromProto(proto) {
    let m = new ListOwnedItemsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filterOptions) {
      m.filterOptions = ListOwnedItemsFilterOptions.fromProto(proto.filterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.filterOptions !== 'undefined' && this.filterOptions !== null) {
      toReturn['filterOptions'] = 'toApiJson' in this.filterOptions ? this.filterOptions.toApiJson() : this.filterOptions;
    }
    return toReturn;
  }
}
class ListOwnedItemsResponse {
  static fromProto(proto) {
    let m = new ListOwnedItemsResponse();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(Item.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DeleteCategoryRequest {
  static fromProto(proto) {
    let m = new DeleteCategoryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    return toReturn;
  }
}
class GetCategoriesRequest {
  static fromProto(proto) {
    let m = new GetCategoriesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetCategoriesResponse {
  static fromProto(proto) {
    let m = new GetCategoriesResponse();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = proto.category.map(MarketplaceCategory.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    return toReturn;
  }
}
class MarketplaceCategory {
  static fromProto(proto) {
    let m = new MarketplaceCategory();
    m = Object.assign(m, proto);
    if (proto.subCategories) {
      m.subCategories = proto.subCategories.map(MarketplaceCategory.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.subCategories !== 'undefined' && this.subCategories !== null) {
      toReturn['subCategories'] = 'toApiJson' in this.subCategories ? this.subCategories.toApiJson() : this.subCategories;
    }
    return toReturn;
  }
}
class UpsertRequest {
  static fromProto(proto) {
    let m = new UpsertRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    if (typeof this.categoryName !== 'undefined') {
      toReturn['categoryName'] = this.categoryName;
    }
    if (typeof this.parentId !== 'undefined') {
      toReturn['parentId'] = this.parentId;
    }
    return toReturn;
  }
}
class UpsertResponse {
  static fromProto(proto) {
    let m = new UpsertResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Fee {
  static fromProto(proto) {
    let m = new Fee();
    m = Object.assign(m, proto);
    if (proto.amountType) {
      m.amountType = enumStringToValue$8(FeeAmountType, proto.amountType);
    }
    if (proto.feeType) {
      m.feeType = enumStringToValue$8(FeeType, proto.feeType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.amountType !== 'undefined') {
      toReturn['amountType'] = this.amountType;
    }
    if (typeof this.feeType !== 'undefined') {
      toReturn['feeType'] = this.feeType;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppPrice {
  static fromProto(proto) {
    let m = new AppPrice();
    m = Object.assign(m, proto);
    if (proto.displayOverride) {
      m.displayOverride = enumStringToValue$7(PriceDisplayOverride, proto.displayOverride);
    }
    if (proto.billingConfiguration) {
      m.billingConfiguration = BillingConfiguration.fromProto(proto.billingConfiguration);
    }
    if (proto.pricesForEditions) {
      m.pricesForEditions = Object.keys(proto.pricesForEditions).reduce((obj, k) => {
        obj[k] = UnitPrice.fromProto(proto.pricesForEditions[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.displayOverride !== 'undefined') {
      toReturn['displayOverride'] = this.displayOverride;
    }
    if (typeof this.billingConfiguration !== 'undefined' && this.billingConfiguration !== null) {
      toReturn['billingConfiguration'] = 'toApiJson' in this.billingConfiguration ? this.billingConfiguration.toApiJson() : this.billingConfiguration;
    }
    if (typeof this.pricesForEditions !== 'undefined' && this.pricesForEditions !== null) {
      toReturn['pricesForEditions'] = 'toApiJson' in this.pricesForEditions ? this.pricesForEditions.toApiJson() : this.pricesForEditions;
    }
    return toReturn;
  }
}
class AppPrices {
  static fromProto(proto) {
    let m = new AppPrices();
    m = Object.assign(m, proto);
    if (proto.pricesForContexts) {
      m.pricesForContexts = Object.keys(proto.pricesForContexts).reduce((obj, k) => {
        obj[k] = AppPrice.fromProto(proto.pricesForContexts[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.pricesForContexts !== 'undefined' && this.pricesForContexts !== null) {
      toReturn['pricesForContexts'] = 'toApiJson' in this.pricesForContexts ? this.pricesForContexts.toApiJson() : this.pricesForContexts;
    }
    return toReturn;
  }
}
class BillingConfiguration {
  static fromProto(proto) {
    let m = new BillingConfiguration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.usesVariablePricing !== 'undefined') {
      toReturn['usesVariablePricing'] = this.usesVariablePricing;
    }
    if (typeof this.usesComponentPricing !== 'undefined') {
      toReturn['usesComponentPricing'] = this.usesComponentPricing;
    }
    if (typeof this.usesEditions !== 'undefined') {
      toReturn['usesEditions'] = this.usesEditions;
    }
    return toReturn;
  }
}
class Commitment {
  static fromProto(proto) {
    let m = new Commitment();
    m = Object.assign(m, proto);
    if (proto.initial) {
      m.initial = parseInt(proto.initial, 10);
    }
    if (proto.recurring) {
      m.recurring = parseInt(proto.recurring, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.initial !== 'undefined') {
      toReturn['initial'] = this.initial;
    }
    if (typeof this.recurring !== 'undefined') {
      toReturn['recurring'] = this.recurring;
    }
    return toReturn;
  }
}
class Discount {
  static fromProto(proto) {
    let m = new Discount();
    m = Object.assign(m, proto);
    if (proto.discountType) {
      m.discountType = enumStringToValue$7(DiscountType, proto.discountType);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.discountType !== 'undefined') {
      toReturn['discountType'] = this.discountType;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class FrequencyPrice {
  static fromProto(proto) {
    let m = new FrequencyPrice();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$7(UnitBillingFrequency, proto.frequency);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.pricingRules) {
      m.pricingRules = proto.pricingRules.map(PricingRule.fromProto);
    }
    if (proto.instancePrice) {
      m.instancePrice = InstancePrice.fromProto(proto.instancePrice);
    }
    if (proto.fees) {
      m.fees = proto.fees.map(Fee.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.pricingRules !== 'undefined' && this.pricingRules !== null) {
      toReturn['pricingRules'] = 'toApiJson' in this.pricingRules ? this.pricingRules.toApiJson() : this.pricingRules;
    }
    if (typeof this.instancePrice !== 'undefined' && this.instancePrice !== null) {
      toReturn['instancePrice'] = 'toApiJson' in this.instancePrice ? this.instancePrice.toApiJson() : this.instancePrice;
    }
    if (typeof this.fees !== 'undefined' && this.fees !== null) {
      toReturn['fees'] = 'toApiJson' in this.fees ? this.fees.toApiJson() : this.fees;
    }
    return toReturn;
  }
}
class FrequencyPrices {
  static fromProto(proto) {
    let m = new FrequencyPrices();
    m = Object.assign(m, proto);
    if (proto.pricesForFrequencies) {
      m.pricesForFrequencies = proto.pricesForFrequencies.map(FrequencyPrice.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricesForFrequencies !== 'undefined' && this.pricesForFrequencies !== null) {
      toReturn['pricesForFrequencies'] = 'toApiJson' in this.pricesForFrequencies ? this.pricesForFrequencies.toApiJson() : this.pricesForFrequencies;
    }
    return toReturn;
  }
}
class InstancePrice {
  static fromProto(proto) {
    let m = new InstancePrice();
    m = Object.assign(m, proto);
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    return toReturn;
  }
}
class AppPricesPricesForContextsEntry {
  static fromProto(proto) {
    let m = new AppPricesPricesForContextsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = AppPrice.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class UnitPricePricesForCurrenciesEntry {
  static fromProto(proto) {
    let m = new UnitPricePricesForCurrenciesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = FrequencyPrices.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class AppPricePricesForEditionsEntry {
  static fromProto(proto) {
    let m = new AppPricePricesForEditionsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = UnitPrice.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class PricingRule {
  static fromProto(proto) {
    let m = new PricingRule();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.max) {
      m.max = parseInt(proto.max, 10);
    }
    if (proto.min) {
      m.min = parseInt(proto.min, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.max !== 'undefined') {
      toReturn['max'] = this.max;
    }
    if (typeof this.min !== 'undefined') {
      toReturn['min'] = this.min;
    }
    return toReturn;
  }
}
class RequestedApp {
  static fromProto(proto) {
    let m = new RequestedApp();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class UnitPrice {
  static fromProto(proto) {
    let m = new UnitPrice();
    m = Object.assign(m, proto);
    if (proto.pricesForCurrencies) {
      m.pricesForCurrencies = Object.keys(proto.pricesForCurrencies).reduce((obj, k) => {
        obj[k] = FrequencyPrices.fromProto(proto.pricesForCurrencies[k]);
        return obj;
      }, {});
    }
    if (proto.discount) {
      m.discount = proto.discount.map(Discount.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricesForCurrencies !== 'undefined' && this.pricesForCurrencies !== null) {
      toReturn['pricesForCurrencies'] = 'toApiJson' in this.pricesForCurrencies ? this.pricesForCurrencies.toApiJson() : this.pricesForCurrencies;
    }
    if (typeof this.discount !== 'undefined' && this.discount !== null) {
      toReturn['discount'] = 'toApiJson' in this.discount ? this.discount.toApiJson() : this.discount;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetMultiPricingRequest {
  static fromProto(proto) {
    let m = new GetMultiPricingRequest();
    m = Object.assign(m, proto);
    if (proto.pricingContexts) {
      m.pricingContexts = FieldMask.fromProto(proto.pricingContexts);
    }
    if (proto.filterOptions) {
      m.filterOptions = FieldMask.fromProto(proto.filterOptions);
    }
    if (proto.requestedApps) {
      m.requestedApps = proto.requestedApps.map(RequestedApp.fromProto);
    }
    if (proto.requestedItems) {
      m.requestedItems = proto.requestedItems.map(RequestedApp.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.pricingContexts !== 'undefined' && this.pricingContexts !== null) {
      toReturn['pricingContexts'] = 'toApiJson' in this.pricingContexts ? this.pricingContexts.toApiJson() : this.pricingContexts;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.filterOptions !== 'undefined' && this.filterOptions !== null) {
      toReturn['filterOptions'] = 'toApiJson' in this.filterOptions ? this.filterOptions.toApiJson() : this.filterOptions;
    }
    if (typeof this.requestedApps !== 'undefined' && this.requestedApps !== null) {
      toReturn['requestedApps'] = 'toApiJson' in this.requestedApps ? this.requestedApps.toApiJson() : this.requestedApps;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.requestedItems !== 'undefined' && this.requestedItems !== null) {
      toReturn['requestedItems'] = 'toApiJson' in this.requestedItems ? this.requestedItems.toApiJson() : this.requestedItems;
    }
    return toReturn;
  }
}
class GetMultiPricingResponse {
  static fromProto(proto) {
    let m = new GetMultiPricingResponse();
    m = Object.assign(m, proto);
    if (proto.appPrices) {
      m.appPrices = proto.appPrices.map(AppPrices.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appPrices !== 'undefined' && this.appPrices !== null) {
      toReturn['appPrices'] = 'toApiJson' in this.appPrices ? this.appPrices.toApiJson() : this.appPrices;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ArchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class AuxiliaryDataFieldSchema {
  static fromProto(proto) {
    let m = new AuxiliaryDataFieldSchema();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$4(AuxiliaryDataFieldType, proto.fieldType);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.dropdownOptions) {
      m.dropdownOptions = proto.dropdownOptions.map(DropdownOption.fromProto);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.fieldDescription !== 'undefined') {
      toReturn['fieldDescription'] = this.fieldDescription;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.dropdownOptions !== 'undefined' && this.dropdownOptions !== null) {
      toReturn['dropdownOptions'] = 'toApiJson' in this.dropdownOptions ? this.dropdownOptions.toApiJson() : this.dropdownOptions;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class AuxiliaryDataObjectID {
  static fromProto(proto) {
    let m = new AuxiliaryDataObjectID();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.objectId !== 'undefined') {
      toReturn['objectId'] = this.objectId;
    }
    return toReturn;
  }
}
class CreateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new CreateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class DropdownOption {
  static fromProto(proto) {
    let m = new DropdownOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class FieldDataUpsertOperation {
  static fromProto(proto) {
    let m = new FieldDataUpsertOperation();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.currencyValue) {
      m.currencyValue = parseInt(proto.currencyValue, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldDataId !== 'undefined') {
      toReturn['fieldDataId'] = this.fieldDataId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.dropdownValue !== 'undefined') {
      toReturn['dropdownValue'] = this.dropdownValue;
    }
    if (typeof this.currencyValue !== 'undefined') {
      toReturn['currencyValue'] = this.currencyValue;
    }
    if (typeof this.deleteValue !== 'undefined') {
      toReturn['deleteValue'] = this.deleteValue;
    }
    return toReturn;
  }
}
class FieldSchemaIdentifier {
  static fromProto(proto) {
    let m = new FieldSchemaIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequestFilters {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onlyArchived !== 'undefined') {
      toReturn['onlyArchived'] = this.onlyArchived;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifiers) {
      m.identifiers = proto.identifiers.map(FieldSchemaIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifiers !== 'undefined' && this.identifiers !== null) {
      toReturn['identifiers'] = 'toApiJson' in this.identifiers ? this.identifiers.toApiJson() : this.identifiers;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.fieldIds !== 'undefined') {
      toReturn['fieldIds'] = this.fieldIds;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataResponse {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListAuxiliaryDataFieldSchemaRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UnarchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UnarchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class UpdateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UpdateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new UpsertAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.fieldDataUpsertOperations) {
      m.fieldDataUpsertOperations = proto.fieldDataUpsertOperations.map(FieldDataUpsertOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.fieldDataUpsertOperations !== 'undefined' && this.fieldDataUpsertOperations !== null) {
      toReturn['fieldDataUpsertOperations'] = 'toApiJson' in this.fieldDataUpsertOperations ? this.fieldDataUpsertOperations.toApiJson() : this.fieldDataUpsertOperations;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class IncludedCommonFormFields {
  static fromProto(proto) {
    let m = new IncludedCommonFormFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.businessAddress !== 'undefined') {
      toReturn['businessAddress'] = this.businessAddress;
    }
    if (typeof this.businessPhoneNumber !== 'undefined') {
      toReturn['businessPhoneNumber'] = this.businessPhoneNumber;
    }
    if (typeof this.businessAccountGroupId !== 'undefined') {
      toReturn['businessAccountGroupId'] = this.businessAccountGroupId;
    }
    if (typeof this.salespersonName !== 'undefined') {
      toReturn['salespersonName'] = this.salespersonName;
    }
    if (typeof this.salespersonPhoneNumber !== 'undefined') {
      toReturn['salespersonPhoneNumber'] = this.salespersonPhoneNumber;
    }
    if (typeof this.salespersonEmail !== 'undefined') {
      toReturn['salespersonEmail'] = this.salespersonEmail;
    }
    if (typeof this.contactName !== 'undefined') {
      toReturn['contactName'] = this.contactName;
    }
    if (typeof this.contactPhoneNumber !== 'undefined') {
      toReturn['contactPhoneNumber'] = this.contactPhoneNumber;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.businessWebsite !== 'undefined') {
      toReturn['businessWebsite'] = this.businessWebsite;
    }
    return toReturn;
  }
}
class OrderFormFieldOption {
  static fromProto(proto) {
    let m = new OrderFormFieldOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class OrderForm {
  static fromProto(proto) {
    let m = new OrderForm();
    m = Object.assign(m, proto);
    if (proto.orderForm) {
      m.orderForm = proto.orderForm.map(OrderFormField.fromProto);
    }
    if (proto.commonForm) {
      m.commonForm = IncludedCommonFormFields.fromProto(proto.commonForm);
    }
    if (proto.commonFormRequiredFields) {
      m.commonFormRequiredFields = IncludedCommonFormFields.fromProto(proto.commonFormRequiredFields);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.commonForm !== 'undefined' && this.commonForm !== null) {
      toReturn['commonForm'] = 'toApiJson' in this.commonForm ? this.commonForm.toApiJson() : this.commonForm;
    }
    if (typeof this.activationMessage !== 'undefined') {
      toReturn['activationMessage'] = this.activationMessage;
    }
    if (typeof this.separateOrderForms !== 'undefined') {
      toReturn['separateOrderForms'] = this.separateOrderForms;
    }
    if (typeof this.commonFormRequiredFields !== 'undefined' && this.commonFormRequiredFields !== null) {
      toReturn['commonFormRequiredFields'] = 'toApiJson' in this.commonFormRequiredFields ? this.commonFormRequiredFields.toApiJson() : this.commonFormRequiredFields;
    }
    if (typeof this.usesPostBillingOrderForm !== 'undefined') {
      toReturn['usesPostBillingOrderForm'] = this.usesPostBillingOrderForm;
    }
    if (typeof this.footerText !== 'undefined') {
      toReturn['footerText'] = this.footerText;
    }
    return toReturn;
  }
}
class OrderFormField {
  static fromProto(proto) {
    let m = new OrderFormField();
    m = Object.assign(m, proto);
    if (proto.maxChoices) {
      m.maxChoices = parseInt(proto.maxChoices, 10);
    }
    if (proto.optionsWithLabels) {
      m.optionsWithLabels = proto.optionsWithLabels.map(OrderFormFieldOption.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    if (typeof this.uploadUrl !== 'undefined') {
      toReturn['uploadUrl'] = this.uploadUrl;
    }
    if (typeof this.prefix !== 'undefined') {
      toReturn['prefix'] = this.prefix;
    }
    if (typeof this.suffix !== 'undefined') {
      toReturn['suffix'] = this.suffix;
    }
    if (typeof this.regexValidator !== 'undefined') {
      toReturn['regexValidator'] = this.regexValidator;
    }
    if (typeof this.regexErrorMessage !== 'undefined') {
      toReturn['regexErrorMessage'] = this.regexErrorMessage;
    }
    if (typeof this.useWebhookValidator !== 'undefined') {
      toReturn['useWebhookValidator'] = this.useWebhookValidator;
    }
    if (typeof this.allowMultiples !== 'undefined') {
      toReturn['allowMultiples'] = this.allowMultiples;
    }
    if (typeof this.allowDuplicates !== 'undefined') {
      toReturn['allowDuplicates'] = this.allowDuplicates;
    }
    if (typeof this.maxChoices !== 'undefined') {
      toReturn['maxChoices'] = this.maxChoices;
    }
    if (typeof this.forOfficeUseOnly !== 'undefined') {
      toReturn['forOfficeUseOnly'] = this.forOfficeUseOnly;
    }
    if (typeof this.optionsWithLabels !== 'undefined' && this.optionsWithLabels !== null) {
      toReturn['optionsWithLabels'] = 'toApiJson' in this.optionsWithLabels ? this.optionsWithLabels.toApiJson() : this.optionsWithLabels;
    }
    if (typeof this.officeEditableOnly !== 'undefined') {
      toReturn['officeEditableOnly'] = this.officeEditableOnly;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FulfillmentOrderConfig {
  static fromProto(proto) {
    let m = new FulfillmentOrderConfig();
    m = Object.assign(m, proto);
    if (proto.release) {
      m.release = enumStringToValue$2(ReleaseType, proto.release);
    }
    if (proto.fulfillmentForm) {
      m.fulfillmentForm = OrderForm.fromProto(proto.fulfillmentForm);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.release !== 'undefined') {
      toReturn['release'] = this.release;
    }
    if (typeof this.defaultExternalFormUrl !== 'undefined') {
      toReturn['defaultExternalFormUrl'] = this.defaultExternalFormUrl;
    }
    if (typeof this.isEnabled !== 'undefined') {
      toReturn['isEnabled'] = this.isEnabled;
    }
    if (typeof this.fulfillmentForm !== 'undefined' && this.fulfillmentForm !== null) {
      toReturn['fulfillmentForm'] = 'toApiJson' in this.fulfillmentForm ? this.fulfillmentForm.toApiJson() : this.fulfillmentForm;
    }
    if (typeof this.usesFulfillmentForm !== 'undefined') {
      toReturn['usesFulfillmentForm'] = this.usesFulfillmentForm;
    }
    return toReturn;
  }
}
class FulfillmentOrderConfigProjectionFilter {
  static fromProto(proto) {
    let m = new FulfillmentOrderConfigProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeExternalFormUrl !== 'undefined') {
      toReturn['includeExternalFormUrl'] = this.includeExternalFormUrl;
    }
    if (typeof this.includeFormConfig !== 'undefined') {
      toReturn['includeFormConfig'] = this.includeFormConfig;
    }
    return toReturn;
  }
}
class GetFulfillmentOrderConfigRequest {
  static fromProto(proto) {
    let m = new GetFulfillmentOrderConfigRequest();
    m = Object.assign(m, proto);
    if (proto.release) {
      m.release = enumStringToValue$2(ReleaseType, proto.release);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = FulfillmentOrderConfigProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.release !== 'undefined') {
      toReturn['release'] = this.release;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class GetFulfillmentOrderConfigResponse {
  static fromProto(proto) {
    let m = new GetFulfillmentOrderConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = FulfillmentOrderConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class UpdateFulfillmentOrderConfigRequest {
  static fromProto(proto) {
    let m = new UpdateFulfillmentOrderConfigRequest();
    m = Object.assign(m, proto);
    if (proto.fulfillmentForm) {
      m.fulfillmentForm = OrderForm.fromProto(proto.fulfillmentForm);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.defaultExternalFormUrl !== 'undefined') {
      toReturn['defaultExternalFormUrl'] = this.defaultExternalFormUrl;
    }
    if (typeof this.isEnabled !== 'undefined') {
      toReturn['isEnabled'] = this.isEnabled;
    }
    if (typeof this.fulfillmentForm !== 'undefined' && this.fulfillmentForm !== null) {
      toReturn['fulfillmentForm'] = 'toApiJson' in this.fulfillmentForm ? this.fulfillmentForm.toApiJson() : this.fulfillmentForm;
    }
    if (typeof this.usesFulfillmentForm !== 'undefined') {
      toReturn['usesFulfillmentForm'] = this.usesFulfillmentForm;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppReportingCodeOverride {
  static fromProto(proto) {
    let m = new AppReportingCodeOverride();
    m = Object.assign(m, proto);
    if (proto.reportingCodeType) {
      m.reportingCodeType = enumStringToValue$1(AppReportingCodeOverrideType, proto.reportingCodeType);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.reportingCodeType !== 'undefined') {
      toReturn['reportingCodeType'] = this.reportingCodeType;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.updatedBy !== 'undefined') {
      toReturn['updatedBy'] = this.updatedBy;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetAppReportingCodeOverrideRequest {
  static fromProto(proto) {
    let m = new GetAppReportingCodeOverrideRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class GetAppReportingCodeOverrideResponse {
  static fromProto(proto) {
    let m = new GetAppReportingCodeOverrideResponse();
    m = Object.assign(m, proto);
    if (proto.appReportingCodeOverride) {
      m.appReportingCodeOverride = AppReportingCodeOverride.fromProto(proto.appReportingCodeOverride);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appReportingCodeOverride !== 'undefined' && this.appReportingCodeOverride !== null) {
      toReturn['appReportingCodeOverride'] = 'toApiJson' in this.appReportingCodeOverride ? this.appReportingCodeOverride.toApiJson() : this.appReportingCodeOverride;
    }
    return toReturn;
  }
}
class UpsertAppReportingCodeOverrideRequest {
  static fromProto(proto) {
    let m = new UpsertAppReportingCodeOverrideRequest();
    m = Object.assign(m, proto);
    if (proto.reportingCodeType) {
      m.reportingCodeType = enumStringToValue(AppReportingCodeOverrideType, proto.reportingCodeType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.reportingCodeType !== 'undefined') {
      toReturn['reportingCodeType'] = this.reportingCodeType;
    }
    return toReturn;
  }
}
class UpsertAppReportingCodeOverrideResponse {
  static fromProto(proto) {
    let m = new UpsertAppReportingCodeOverrideResponse();
    m = Object.assign(m, proto);
    if (proto.appReportingCodeOverride) {
      m.appReportingCodeOverride = AppReportingCodeOverride.fromProto(proto.appReportingCodeOverride);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appReportingCodeOverride !== 'undefined' && this.appReportingCodeOverride !== null) {
      toReturn['appReportingCodeOverride'] = 'toApiJson' in this.appReportingCodeOverride ? this.appReportingCodeOverride.toApiJson() : this.appReportingCodeOverride;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': '',
  'test': '',
  'demo': 'marketplace-apps-api-demo.apigateway.co',
  'prod': 'marketplace-apps-api-prod.apigateway.co',
  'production': 'marketplace-apps-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AppPricingApiService = /*#__PURE__*/(() => {
  class AppPricingApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiPricing(r) {
      const request = r.toApiJson ? r : new GetMultiPricingRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.AppPricing/GetMultiPricing", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiPricingResponse.fromProto(resp)));
    }
  }
  AppPricingApiService.ɵfac = function AppPricingApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AppPricingApiService)();
  };
  AppPricingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AppPricingApiService,
    factory: AppPricingApiService.ɵfac,
    providedIn: 'root'
  });
  return AppPricingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AppReportingCodeOverridesApiService = /*#__PURE__*/(() => {
  class AppReportingCodeOverridesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetAppReportingCodeOverrideRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.AppReportingCodeOverrides/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppReportingCodeOverrideResponse.fromProto(resp)));
    }
    upsert(r) {
      const request = r.toApiJson ? r : new UpsertAppReportingCodeOverrideRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.AppReportingCodeOverrides/Upsert", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpsertAppReportingCodeOverrideResponse.fromProto(resp)));
    }
  }
  AppReportingCodeOverridesApiService.ɵfac = function AppReportingCodeOverridesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AppReportingCodeOverridesApiService)();
  };
  AppReportingCodeOverridesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AppReportingCodeOverridesApiService,
    factory: AppReportingCodeOverridesApiService.ɵfac,
    providedIn: 'root'
  });
  return AppReportingCodeOverridesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CategoryApiService = /*#__PURE__*/(() => {
  class CategoryApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsert(r) {
      const request = r.toApiJson ? r : new UpsertRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Category/Upsert", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpsertResponse.fromProto(resp)));
    }
    getCategories(r) {
      const request = r.toApiJson ? r : new GetCategoriesRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Category/GetCategories", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCategoriesResponse.fromProto(resp)));
    }
    deleteCategory(r) {
      const request = r.toApiJson ? r : new DeleteCategoryRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Category/DeleteCategory", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CategoryApiService.ɵfac = function CategoryApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CategoryApiService)();
  };
  CategoryApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CategoryApiService,
    factory: CategoryApiService.ɵfac,
    providedIn: 'root'
  });
  return CategoryApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let FulfillmentOrderConfigApiService = /*#__PURE__*/(() => {
  class FulfillmentOrderConfigApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getFulfillmentOrderConfig(r) {
      const request = r.toApiJson ? r : new GetFulfillmentOrderConfigRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.FulfillmentOrderConfigService/GetFulfillmentOrderConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFulfillmentOrderConfigResponse.fromProto(resp)));
    }
    updateFulfillmentOrderConfig(r) {
      const request = r.toApiJson ? r : new UpdateFulfillmentOrderConfigRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.FulfillmentOrderConfigService/UpdateFulfillmentOrderConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  FulfillmentOrderConfigApiService.ɵfac = function FulfillmentOrderConfigApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FulfillmentOrderConfigApiService)();
  };
  FulfillmentOrderConfigApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FulfillmentOrderConfigApiService,
    factory: FulfillmentOrderConfigApiService.ɵfac,
    providedIn: 'root'
  });
  return FulfillmentOrderConfigApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ItemsApiService = /*#__PURE__*/(() => {
  class ItemsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listOwnedItems(r) {
      const request = r.toApiJson ? r : new ListOwnedItemsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Items/ListOwnedItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListOwnedItemsResponse.fromProto(resp)));
    }
    listActivatableItems(r) {
      const request = r.toApiJson ? r : new ListActivatableItemsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Items/ListActivatableItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActivatableItemsResponse.fromProto(resp)));
    }
    listDependencies(r) {
      const request = r.toApiJson ? r : new ListDependenciesRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Items/ListDependencies", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDependenciesResponse.fromProto(resp)));
    }
    getMultiDependentItems(r) {
      const request = r.toApiJson ? r : new GetMultiDependentItemsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Items/GetMultiDependentItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiDependentItemsResponse.fromProto(resp)));
    }
    getItemDependencyTree(r) {
      const request = r.toApiJson ? r : new GetItemDependencyTreeRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Items/GetItemDependencyTree", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetItemDependencyTreeResponse.fromProto(resp)));
    }
  }
  ItemsApiService.ɵfac = function ItemsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ItemsApiService)();
  };
  ItemsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ItemsApiService,
    factory: ItemsApiService.ɵfac,
    providedIn: 'root'
  });
  return ItemsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let MarketplaceAppDataApiService = /*#__PURE__*/(() => {
  class MarketplaceAppDataApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiAppData(r) {
      const request = r.toApiJson ? r : new GetMultiAppDataRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.MarketplaceAppData/GetMultiAppData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAppDataResponse.fromProto(resp)));
    }
    listAppIDsByMultiTag(r) {
      const request = r.toApiJson ? r : new ListAppIDsByMultiTagRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.MarketplaceAppData/ListAppIDsByMultiTag", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAppIDsByMultiTagResponse.fromProto(resp)));
    }
    listValuesByMultiKind(r) {
      const request = r.toApiJson ? r : new ListValuesByMultiKindRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.MarketplaceAppData/ListValuesByMultiKind", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListValuesByMultiKindResponse.fromProto(resp)));
    }
    tagApps(r) {
      const request = r.toApiJson ? r : new TagAppsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.MarketplaceAppData/TagApps", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    untagApps(r) {
      const request = r.toApiJson ? r : new UntagAppsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.MarketplaceAppData/UntagApps", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listByMultiTag(r) {
      const request = r.toApiJson ? r : new ListByMultiTagRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.MarketplaceAppData/ListByMultiTag", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListByMultiTagResponse.fromProto(resp)));
    }
  }
  MarketplaceAppDataApiService.ɵfac = function MarketplaceAppDataApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MarketplaceAppDataApiService)();
  };
  MarketplaceAppDataApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MarketplaceAppDataApiService,
    factory: MarketplaceAppDataApiService.ɵfac,
    providedIn: 'root'
  });
  return MarketplaceAppDataApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PartnerApiService = /*#__PURE__*/(() => {
  class PartnerApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiApp(r) {
      const request = r.toApiJson ? r : new GetMultiAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Partner/GetMultiApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAppResponse.fromProto(resp)));
    }
    listPartnerEnabledApps(r) {
      const request = r.toApiJson ? r : new ListPartnerEnabledAppsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Partner/ListPartnerEnabledApps", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPartnerEnabledAppsResponse.fromProto(resp)));
    }
    replaceAppSettings(r) {
      const request = r.toApiJson ? r : new ReplaceAppSettingsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Partner/ReplaceAppSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => ReplaceAppSettingsResponse.fromProto(resp)));
    }
    getAppSettings(r) {
      const request = r.toApiJson ? r : new GetAppSettingsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Partner/GetAppSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppSettingsResponse.fromProto(resp)));
    }
    listAppSettings(r) {
      const request = r.toApiJson ? r : new ListAppSettingsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Partner/ListAppSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAppSettingsResponse.fromProto(resp)));
    }
    replaceUpgradeDialogContent(r) {
      const request = r.toApiJson ? r : new ReplaceUpgradeDialogContentRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Partner/ReplaceUpgradeDialogContent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getUpgradeDialogContent(r) {
      const request = r.toApiJson ? r : new GetUpgradeDialogContentRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Partner/GetUpgradeDialogContent", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUpgradeDialogContentResponse.fromProto(resp)));
    }
    suggestProduct(r) {
      const request = r.toApiJson ? r : new SuggestProductRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Partner/SuggestProduct", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getPurchaseLink(r) {
      const request = r.toApiJson ? r : new GetPurchaseLinkRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.Partner/GetPurchaseLink", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPurchaseLinkResponse.fromProto(resp)));
    }
  }
  PartnerApiService.ɵfac = function PartnerApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerApiService)();
  };
  PartnerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerApiService,
    factory: PartnerApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ProductAuxiliaryFieldDataApiService = /*#__PURE__*/(() => {
  class ProductAuxiliaryFieldDataApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listAuxiliaryData(r) {
      const request = r.toApiJson ? r : new ListAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldData/ListAuxiliaryData", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataResponse.fromProto(resp)));
    }
    upsertAuxiliaryData(r) {
      const request = r.toApiJson ? r : new UpsertAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldData/UpsertAuxiliaryData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiAuxiliaryData(r) {
      const request = r.toApiJson ? r : new GetMultiAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldData/GetMultiAuxiliaryData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAuxiliaryDataResponse.fromProto(resp)));
    }
  }
  ProductAuxiliaryFieldDataApiService.ɵfac = function ProductAuxiliaryFieldDataApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProductAuxiliaryFieldDataApiService)();
  };
  ProductAuxiliaryFieldDataApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProductAuxiliaryFieldDataApiService,
    factory: ProductAuxiliaryFieldDataApiService.ɵfac,
    providedIn: 'root'
  });
  return ProductAuxiliaryFieldDataApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ProductAuxiliaryFieldSchemaApiService = /*#__PURE__*/(() => {
  class ProductAuxiliaryFieldSchemaApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new CreateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldSchema/CreateAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldSchema/GetAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    getMultiAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetMultiAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldSchema/GetMultiAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    listAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ListAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldSchema/ListAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    updateAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UpdateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldSchema/UpdateAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    archiveAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ArchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldSchema/ArchiveAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unarchiveAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UnarchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v2.ProductAuxiliaryFieldSchema/UnarchiveAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ProductAuxiliaryFieldSchemaApiService.ɵfac = function ProductAuxiliaryFieldSchemaApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProductAuxiliaryFieldSchemaApiService)();
  };
  ProductAuxiliaryFieldSchemaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProductAuxiliaryFieldSchemaApiService,
    factory: ProductAuxiliaryFieldSchemaApiService.ɵfac,
    providedIn: 'root'
  });
  return ProductAuxiliaryFieldSchemaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, ActivatableItemSummary, ActivationInformation, App, AppKey, AppKeyWithQuantity, AppLevelAdminDashboard, AppLevelAdminDashboardEnabled, AppPrice, AppPricePricesForEditionsEntry, AppPrices, AppPricesPricesForContextsEntry, AppPricingApiService, AppReportingCodeOverride, AppReportingCodeOverrideType, AppReportingCodeOverridesApiService, AppRestrictions, AppSettings, AppTag, AppType, ArchiveAuxiliaryDataFieldSchemaRequest, AutoActivation, AuxiliaryDataFieldSchema, AuxiliaryDataFieldType, AuxiliaryDataObjectID, BasicIntegration, BillingConfiguration, Branding, CategoryApiService, ChildApp, Commitment, CreateAuxiliaryDataFieldSchemaRequest, DeleteCategoryRequest, DeliveryMethod, DependentItems, Discount, DiscountType, DropdownOption, Edition, EditionChange, EditionIdentifier, EditionInformation, EditionRequirement, EditionUpgradeAction, EndOfTrialActions, EndUserMarketingInformation, ExternalIdentifiers, Fee, FeeAmountType, FeeType, FieldDataUpsertOperation, FieldMask, FieldSchemaIdentifier, FrequencyPrice, FrequencyPrices, FrequentlyAskedQuestions, FulfillmentOrderConfig, FulfillmentOrderConfigApiService, FulfillmentOrderConfigProjectionFilter, GetAppReportingCodeOverrideRequest, GetAppReportingCodeOverrideResponse, GetAppSettingsRequest, GetAppSettingsResponse, GetAuxiliaryDataFieldSchemaRequest, GetAuxiliaryDataFieldSchemaResponse, GetCategoriesRequest, GetCategoriesResponse, GetFulfillmentOrderConfigRequest, GetFulfillmentOrderConfigResponse, GetItemDependencyTreeRequest, GetItemDependencyTreeResponse, GetMultiAppDataRequest, GetMultiAppDataResponse, GetMultiAppRequest, GetMultiAppResponse, GetMultiAuxiliaryDataFieldSchemaRequest, GetMultiAuxiliaryDataFieldSchemaResponse, GetMultiAuxiliaryDataRequest, GetMultiAuxiliaryDataResponse, GetMultiDependentItemsRequest, GetMultiDependentItemsResponse, GetMultiDependentItemsResponseDependentItemsEntry, GetMultiPricingRequest, GetMultiPricingResponse, GetPurchaseLinkRequest, GetPurchaseLinkResponse, GetUpgradeDialogContentRequest, GetUpgradeDialogContentResponse, IncludedCommonFormFields, InstancePrice, Item, ItemDependencyNode, ItemIdentifier, ItemType, ItemsApiService, KindValues, ListActivatableItemsFilters, ListActivatableItemsRequest, ListActivatableItemsResponse, ListActivatableItemsSortField, ListActivatableItemsSortOptions, ListAppIDsByMultiTagRequest, ListAppIDsByMultiTagResponse, ListAppSettingsRequest, ListAppSettingsResponse, ListAuxiliaryDataFieldSchemaRequest, ListAuxiliaryDataFieldSchemaRequestFilters, ListAuxiliaryDataFieldSchemaResponse, ListAuxiliaryDataRequest, ListAuxiliaryDataResponse, ListByMultiTagRequest, ListByMultiTagResponse, ListDependenciesRequest, ListDependenciesRequiredItem, ListDependenciesRequiredItems, ListDependenciesResponse, ListDependenciesResponseMissingItemsEntry, ListOwnedItemsFilterOptions, ListOwnedItemsFilterOptionsAppType, ListOwnedItemsRequest, ListOwnedItemsResponse, ListPartnerEnabledAppsRequest, ListPartnerEnabledAppsRequestListAppsFilter, ListPartnerEnabledAppsResponse, ListValuesByMultiKindRequest, ListValuesByMultiKindResponse, LmiCategory, MCPOptions, MarketplaceApp, MarketplaceAppDataApiService, MarketplaceCategory, OrderForm, OrderFormField, OrderFormFieldOption, OrderFormFilter, PagedRequestOptions, PagedResponseMetadata, PartnerApiService, PermissionLists, Price, PriceDisplayOverride, PricingRule, ProductAuxiliaryFieldDataApiService, ProductAuxiliaryFieldSchemaApiService, ProductSuggestion, ReleaseType, ReplaceAppSettingsRequest, ReplaceAppSettingsResponse, ReplaceUpgradeDialogContentRequest, RequestedApp, RequiredBusinessData, RequiredItem, RequiredParent, RequiredParentDetails, SSOIntegration, ScopedTag, SharedMarketingInformation, SortDirection, SuggestProductRequest, SuggestionReason, Tag, TagAppsRequest, Trial, TrialConfiguration, UnarchiveAuxiliaryDataFieldSchemaRequest, UnitBillingFrequency, UnitPrice, UnitPricePricesForCurrenciesEntry, UntagAppsRequest, UpdateAuxiliaryDataFieldSchemaRequest, UpdateFulfillmentOrderConfigRequest, UpgradeDialogContent, UpsertAppReportingCodeOverrideRequest, UpsertAppReportingCodeOverrideResponse, UpsertAuxiliaryDataRequest, UpsertRequest, UpsertResponse };
